<template>
    <div>
        <!--<button type="button" class="btn btn-primary mb-2" :disabled="loading" @click="handleAddClick">Add</button>-->
        <div class="row border-bottom">
            <div class="col-12">
                <div class="mb-2 float-right">
                    <div class="row">
                        <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                            <div class="btn-toolbar" role="toolbar">
                                <div class="btn-group btn-group-justified" role="group">
                                    <div class="btn-group" role="group">
                                        <button id="refresh-bank-details" class="btn btn-primary" data-original-title="Refresh" @click="refresh()"><i class="fas fa-sync-alt" aria-hidden="true"></i></button>
                                        <b-tooltip target="refresh-bank-details" triggers="hover">
                                            Refresh bank details list
                                        </b-tooltip>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button id="new-bank-details" class="btn btn-primary" data-original-title="new"><i class="fas fas fa-plus" aria-hidden="true" @click="handleAddClick()"></i></button>
                                        <b-tooltip target="new-bank-details" triggers="hover">
                                            Add bank details
                                        </b-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading && loading == true" class="row align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <table v-else class="table">
            <thead>
                <tr>
                    <td colspan="9">
                        <p>Bank account should be in the name of the claimant, <strong>{{claimantName}}</strong>!  If there is a <span class="badge badge-danger">Check</span> in the Name column then the account is possibly for another person / organisation.</p>
                    </td>
                </tr>
                <tr>
                    <th scope="col">Bank / Building Society Name</th>
                    <th scope="col">Name</th>
                    <th scope="col">Number</th>
                    <th scope="col">Sortcode</th>
                    <th scope="col">Created</th>
                    <th scope="col">Created By</th>
                    <th scope="col">Last Updated</th>
                    <th scope="col">Last Updated By</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(itm, idx) in checkedBankDetails" :key="'claimbankdetailslist_' + idx"
                    :class="selectedRowIndex == idx ? 'table-primary' : ''"
                    :style="'cursor: pointer'"
                    @click="handleRowClick(idx, itm)">
                    <td>{{itm.name}}</td>
                    <td>
                        {{itm.accountName}} 
                        <span v-if="itm.distance && itm.distance >= 5"class="badge badge-danger">Check</span>
                    </td>
                    <td>{{itm.accountNumber}}</td>
                    <td>{{itm.accountSortcode}}</td>
                    <td>{{itm.dateCreatedFormated}}</td>
                    <td>{{itm.createdByName}}</td>
                    <td>{{itm.dateLastUpdatedFormated}}</td>
                    <td>{{itm.lastUpdatedByName}}</td>
                    <td>
                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'">
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                <span class="sr-only">Actions menu</span>
                            </template>
                            <b-dropdown-item href="javascript:void(0)" @click="handleEditClick(idx,itm)">
                                <i v-if="false" :class="iconClass"></i> Edit
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleDeleteClick(idx,itm)">
                                <i v-if="false" :class="iconClass"></i> Delete
                            </b-dropdown-item>
                        </b-dropdown>
                    </td>
                </tr>
            </tbody>
        </table>
        <b-modal :id="'claim-bank-details-edit-modal-' + $vnode.key" title="Claim Bank Details" size="lg" hide-footer>
            <div v-if="selectedItem || mode == 1">
                <div class="row mt-2">
                    <div class="col pl-4 p-2">
                        <span>Bank / Building Society Name</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="bankDetailsName" v-model="editBankDetailsModel.name">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'name').isValid">
                            {{editBankDetailsModel.validators.find(v => v.item == 'name').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Account Name</span>
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #8b8686;" v-show="claimantName">
                            Bank account should be in the name of the claimant, <strong>{{claimantName}}</strong>.
                        </div>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="bankDetailsAccountName" v-model="editBankDetailsModel.accountName">
                        <!--<div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #8b8686;" v-show="claimantName">
                            Bank account should be in the name of the claimant, {{claimantName}}.
                        </div>-->
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'accountName').isValid">
                            {{editBankDetailsModel.validators.find(v => v.item == 'accountName').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Account Number</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="bankDetailsAccountNumber" v-model="editBankDetailsModel.accountNumber">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'accountNumber').isValid">
                            {{editBankDetailsModel.validators.find(v => v.item == 'accountNumber').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Account Sortcode</span>
                        <small class="form-text text-muted">No spaces or hyphens.</small>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="bankDetailsAccountSortcode" v-model="editBankDetailsModel.accountSortcode">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'accountSortcode').isValid">
                            {{editBankDetailsModel.validators.find(v => v.item == 'accountSortcode').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" :disabled="loading" @click="handleCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!editBankDetailsModelIsValid() || loading" @click="handleOKClick()">OK</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    import axios from 'axios'
    import { API_BASE_URL } from '../globalVar'

    import { required, numeric, minLen, maxLen } from '@/util/validators'
    import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'

    import watchAll from '@/mixins/watchAll.js'
    import validator from '@/mixins/validator.js'

    import { calculateLevenshteinDistance } from '@/util/calculateLevenshteinDistance.js'

    export default {
        name: 'ClaimBankDetails',
        props: {
            claimId: {
                type: Number,
                required: true
            },
            load: Boolean,
            claimantName: {
                type: String,
                required: false,
                default: () => { return null }
            }
        },
        mixins: [
            watchAll,
            validator
        ],
        components: {},
        data: () => {
            return {
                baseUrl: API_BASE_URL,
                bankDetails: [],
                selectedRowIndex: null,
                selectedItem: null,
                mode: null, // 1 add, 2 edit

                editBankDetailsModel: {
                    name: null,
                    accountName: null,
                    accountNumber: null,
                    accountSortcode: null,
                    validators: [
                        {
                            item: 'name',
                            validators: [
                                required
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'accountName',
                            validators: [
                                required
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'accountNumber',
                            validators: [
                                required, numeric, minLen(8), maxLen(8)
                            ],
                            isValid: false,
                            inValidFeedback: 'Required, 8 digits'
                        },
                        {
                            item: 'accountSortcode',
                            validators: [
                                required, numeric, minLen(6), maxLen(6)
                            ],
                            isValid: false,
                            inValidFeedback: 'Required, 6 digits'
                        }
                    ]
                },
                loading: false
            }
        },
        watch: {
            load: async function (newVal, oldVal) {
                if (newVal == true) {
                    await this.getBankDetailsForClaim(this.claimId)
                }
            }
        },
        computed: {
            checkedBankDetails() {
                try {
                    if (this.bankDetails) {
                        const updatedArray = this.bankDetails.map((element) => ({
                            ...element,
                            distance: calculateLevenshteinDistance(this.claimantName, element.accountName)
                        }));
                        return updatedArray
                    }
                    return []
                } catch (err) {
                    return this.bankDetails
                } 
            }
        },
        methods: {
            async refresh() {
                await this.getBankDetailsForClaim(this.claimId)
            },
            async getBankDetailsForClaim(claimId) {
                if (claimId && !isNaN(claimId)) {
                    this.loading = true
                    try {
                        const response = await axios.get('/api/admin/v1/finance/bankdetails/' + claimId)
                        const { data } = response
                        this.bankDetails = data
                    } catch (error) {
                        console.error(error)
                    } finally {
                        this.loading = false
                        this.$emit('finished-loading')
                    }
                }
            },
            handleRowClick(rowIndex, item) {
                this.selectedRowIndex = rowIndex
            },
            handleAddClick() {
                this.selectedItem = null
                this.editBankDetailsModel.name = null
                this.editBankDetailsModel.accountName = null
                this.editBankDetailsModel.accountNumber = null
                this.editBankDetailsModel.accountSortcode = null
                this.mode = 1
                this.$bvModal.show('claim-bank-details-edit-modal-' + this.$vnode.key)
            },
            handleEditClick(rowIndex, item) {
                this.selectedItem = item
                this.editBankDetailsModel.name = item.name
                this.editBankDetailsModel.accountName = item.accountName
                this.editBankDetailsModel.accountNumber = item.accountNumber
                this.editBankDetailsModel.accountSortcode = item.accountSortcode
                this.mode = 2
                this.$bvModal.show('claim-bank-details-edit-modal-' + this.$vnode.key)
            },
            async handleDeleteClick(rowIndex, item) {
                this.selectedItem = item

                const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Delete these Bank Details?')
                if (confirm != null) {
                    if (confirm == true) {
                        let { id, rv } = this.selectedItem
                        let payload = {
                            id,
                            rv
                        }
                        
                        this.loading = true
                        try {
                            const response = await axios.post('/api/admin/v1/finance/delbankdetails/', payload)
                            const { data } = response
                            if (data) {
                                if (data.deleted == true)
                                    this.bankDetails = this.bankDetails.filter(i => i.id !== data.id)
                            }

                        } catch (error) {
                            console.error(error)
                        } finally { this.loading = false }
                    }
                }
            },
            editBankDetailsModelRunValidators() { runValidators(this.editBankDetailsModel) },
            editBankDetailsModelIsValid() { return getValidatorsIsValid(this.editBankDetailsModel) },
            async handleOKClick() {
                let { name, accountName, accountNumber, accountSortcode } = this.editBankDetailsModel
                let payload = {
                    claimId: this.claimId,
                    name,
                    accountName,
                    accountNumber,
                    accountSortcode
                }
                if (this.mode == 1) {
                    this.loading = true
                    try {
                        const response = await axios.post('/api/admin/v1/finance/addbankdetails/', payload)
                        const { data } = response
                        if (data) {
                            this.bankDetails = this.bankDetails = [data, ...this.bankDetails] //.unshift(data) //.map(i => i.id !== data.id ? i : data)
                            this.$bvModal.hide('claim-bank-details-edit-modal-' + this.$vnode.key)
                        }

                    } catch (error) {
                        console.error(error)
                    } finally { this.loading = false }

                } else if (this.mode == 2) {
                    let { id, rv } = this.selectedItem
                    payload.id = id
                    payload.rv = rv
                    this.loading = true
                    try {
                        const response = await axios.post('/api/admin/v1/finance/editbankdetails/', payload)
                        const { data } = response
                        if (data) {
                            this.bankDetails = this.bankDetails.map(i => i.id !== data.id ? i : data)
                            this.$bvModal.hide('claim-bank-details-edit-modal-' + this.$vnode.key)
                        }

                    } catch (error) {
                        console.error(error)
                    } finally { this.loading = false }
                } else {

                }
            },
            async handleCreateClaimPaymentClick(idx, itm) {


                console.log('-i : ', itm)
                this.loading = true
                try {


                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
            },
            handleCloseClick() {
                this.$bvModal.hide('claim-bank-details-edit-modal-' + this.$vnode.key)
                this.selectedItem = null
                //this.editAmountModel.net = 0
                //this.editAmountModel.tax = 0
                //this.editAmountModel.gross = 0
            }
        },
        async mounted() {
            this.watchAll(['editBankDetailsModel.name', 'editBankDetailsModel.accountName', 'editBankDetailsModel.accountNumber', 'editBankDetailsModel.accountSortcode'],
                this.editBankDetailsModelRunValidators.bind(this))

        }
    }
</script>